
import { IDotThi } from "../../../model/respone/tct/IDotThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotThiActionsObj = {
    LOAD_START: {} as { nam_hoc: string, hoc_ky: number },
    LOAD_SUCCESS: {} as IDotThi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IDotThi | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDotThi,
    SAVE_SUCCESS: {} as IDotThi,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
};
export const eDotThiActionIds = generateActionTypeIds(
    eDotThiActionsObj,
    "DOT_THI"
);
export type IDotThiActionTypes = IGenericActionType<
    typeof eDotThiActionsObj,
    "DOT_THI"
>;
